import React from "react";
import T from "../../../services/lang/LanguageService";

const DevSandbox = () => {
  return (
      <div>
          <li>{T("greeting", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("mango.ango", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("from", {name: " 2200"})}</li>
          <li>{T("to", {name: "2100"})}</li>
          <li>{T("side-menu.home", {name: "Menu!!"})}</li>
      </div>
  );
};

export default DevSandbox;


